<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{$t('Coper-Self-invoice')}}</v-toolbar-title>
              <v-spacer></v-spacer>

              <!-- <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu> -->
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>

                <v-flex xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>

                      <v-flex xs12 sm6 pt-2 md2>
                        <v-select :label="$t('Date-Type')" items-value="value" item-text="text" :items="itemstarihtip"
                          v-model="tarihTip"></v-select>
                      </v-flex>

                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBasla" v-model="KayitTarihiBasla"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBitis" v-model="KayitTarihiBitis"></tarihcomp>
                      </v-flex>


                      <v-flex pt-2>
                        <v-layout>
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout pt-3 align-center>
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">check_circle_outline</v-icon>
                            </template>

                            <v-btn small @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom :activator="el" v-model="tooltip">
                              <span>{{$t('Add-Search-Filter')}}</span>
                            </v-tooltip>
                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>




                <v-flex xs12 pt-2 sm6 pr-2 md4>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap class="pl-1 pr-1 project overdue">
                        <v-toolbar flat="" size="120px" dark color="white">
                          <v-toolbar-title> <span class="subheading black--text">
                              {{$t('Records')}}
                            </span> 
                            </v-toolbar-title>
                          <v-spacer></v-spacer>
                            <v-flex xs12 sm4 md4 v-if="dizaynData.length!=0">
                               <v-layout justify-start>
                                 <v-btn flat @click="ItemAktarTumu(dizaynData,dizaynData2)" color="green">
                                 {{this.$t('Choose-All')}}
                                   <v-icon color="green">
                                     double_arrow
                                   </v-icon>
                                 </v-btn>                                     
                              </v-layout>

                             </v-flex>
                        </v-toolbar>
                      </v-layout>
                    </v-flex>


                    <v-flex xs12 sm12 md12>
                      <v-card color="grey lighten-5" flat>
                        <v-layout row wrap>
                          <v-flex pt-2 xs12 sm12 md12>
                            <v-card flat>
                              <v-layout  row wrap>
                          <v-flex v-if="dizaynData.length==0" xs12 md12>
                            <v-layout class="pa-3" row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-layout justify-left>
                                  <div class="body-2 	 justify-center   grey--text">{{$t('No-Records')}}</div>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>


                                <v-flex v-if="dizaynData.length!=0"  xs12 pt-2 pb-2 md12>

                                  <v-layout row wrap>


                                    <v-flex xs2 pl-1 sm1 md2>

                                      <v-layout justify-left>
                                        <div class="body-2 	 justify-center   grey--text">PNR</div>
                                      </v-layout>

                                    </v-flex>

                                    <v-flex xs3 sm2 md3>

                                      <v-layout justify-left>
                                        <div class="justify-center body-2 grey--text">{{ $t('Registration-Date') }}</div>
                                      </v-layout>

                                    </v-flex>


                                    <v-flex xs3 sm2 md2>
                                      <v-layout justify-left>
                                        <div class="body-2 	 justify-center   grey--text">{{$t('Currentcode_label')}}</div>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs2 sm2 md2>

                                      <v-layout justify-left>
                                        <div class="justify-center body-2 grey--text">{{ $t('Name') }}</div>
                                      </v-layout>

                                    </v-flex>



                                    <v-flex xs2 sm2 md2>

                                      <v-layout justify-left>
                                        <div class="justify-center body-2  grey--text"> {{ $t('E-Invoice') }}</div>
                                      </v-layout>

                                    </v-flex>

                                    <v-flex xs12 sm1 md1>

                                      
                                      <v-layout justify-left>
                                        <div class="justify-center body-2  grey--text"></div>
                                      </v-layout>

                                    </v-flex>
 
                                  </v-layout>

                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 md12>
                            <v-divider></v-divider>
                          </v-flex>

                          <v-flex v-if="dizaynData.length!=0" xs12 md12>
                            <div class="scrollbar1" id="style-11">
                              <v-flex v-for="element in dizaynData" :key="element.PNR_No" xs12 md12>

                                <v-layout align-center fill-height row wrap>


                                  <v-flex pl-1 xs2 sm1 md2>

                                    <v-layout justify-left>
                                      <div class="body-2 	 justify-center   grey--text">{{element.PNR_No}}</div>
                                    </v-layout>

                                  </v-flex>

                                  <v-flex xs2 sm2 md3>

                                    <v-layout justify-left>
                                      <div class="justify-center body-2 grey--text">
                                        {{element.Kayit_Tarihi | dateformat}}
                                      </div>
                                    </v-layout>
                                  </v-flex>


                                     <v-flex xs2 sm2 md2>

                                    <v-layout row full-width wrap justify-left>
                                      <div class="body-2 grey--text text-truncate">{{element.Cari_Kod}}</div>
                                    </v-layout>

                                  </v-flex>


                                <v-flex xs2 sm md3>

                                <v-layout justify-left>
                                  <div class="justify-center body-2 grey--text text-truncate">
                                    {{element.KisiIsim}}
                                  </div>
                                </v-layout>
                              </v-flex>

                               



                                  <v-flex xs2 sm2 md1>

                                    <v-layout justify-left>
                                      <div class="justify-center body-2  grey--text">{{element.EFatura}}</div>
                                    </v-layout>

                                  </v-flex>



                                  <v-flex xs2 sm1 md1>

                                    <v-layout justify-left>
                                      <v-btn icon ripple>
                                        <v-icon @click="ItemAktar(dizaynData,dizaynData2,element)" color="green">
                                          arrow_forward_ios
                                        </v-icon>
                                      </v-btn>
                                    </v-layout>

                                  </v-flex>
                                  <v-flex xs2 sm12 md12>
                                    <v-divider></v-divider>
                                  </v-flex>




                                </v-layout>

                              </v-flex>
                            </div>
                          </v-flex>


                        </v-layout>

                      </v-card>


                    </v-flex>

                  </v-layout>



                </v-flex>


                <v-flex xs12 pt-2 sm6 md8>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap class="pl-1 pr-1 project complete">
                        <v-toolbar flat="" size="120px" dark color="white">
                          <v-toolbar-title> <span class="subheading black--text">
                              {{$t('Records-Selected')}}
                            </span> </v-toolbar-title>
                          <v-spacer></v-spacer>
                        </v-toolbar>
                      </v-layout>
                    </v-flex>


                    <v-flex pt-2 xs12 sm12 md12>
                      <v-card flat>
                        <v-layout row wrap class="pa-3 ">

                          <v-flex v-if="dizaynData2.length==0" xs12 md12>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-layout justify-left>
                                  <div class="body-2 	 justify-center   grey--text">{{$t('No-Records')}}</div>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>





                          <v-flex v-if="dizaynData2.length>0" xs12 md12>
                            <v-layout row wrap>
                              <v-flex xs2 sm1 md1>

                                <v-layout justify-left>
                                  <div class="body-2 	 justify-center   grey--text"></div>
                                </v-layout>

                              </v-flex>


                              <v-flex xs2 sm1 md1>

                                <v-layout justify-left>
                                  <div class="body-2 	 justify-center   grey--text">PNR</div>
                                </v-layout>

                              </v-flex>

                              <v-flex xs2 sm1 md1>

                                <v-layout justify-left>
                                  <div class="justify-center body-2 grey--text">{{ $t('Registration-Date') }}</div>
                                </v-layout>

                              </v-flex>

                              <v-flex xs2 sm2 md2 pl-4>
                                <v-layout justify-left>
                                  <div class="body-2 	 justify-center   grey--text">{{$t('Currentcode_label')}}</div>
                                </v-layout>
                              </v-flex>

                                 <v-flex xs2 sm2 md2>
                                <v-layout justify-left>
                                  <div class="body-2 	 justify-center   grey--text">{{ $t('Name') }} </div>
                                </v-layout>
                              </v-flex>

                              <v-flex xs2 sm1 md1 pr-4>
                                <v-layout justify-left>
                                  <div class="body-2 	 justify-center   grey--text">{{$t('Invoice-Date')}}</div>
                                </v-layout>
                              </v-flex>

                              <v-flex xs2 sm2 md2 pl-4>
                                <v-layout justify-left>
                                  <div class="body-2 	 justify-left   grey--text">{{$t('Maturity-Date')}}</div>
                                </v-layout>
                              </v-flex>


                              <v-flex xs12 sm2 md1>

                                <v-layout justify-left>
                                  <div class="justify-center body-2  grey--text">{{ $t('E-Invoice') }}  </div>
                                </v-layout>

                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 v-if="dizaynData.length>0" md12>
                            <v-divider></v-divider>
                          </v-flex>

                          <v-flex v-for="element in dizaynData2" :key="element.kayit.PNR_No" xs12 md12>
                            <v-layout align-center fill-height row wrap>

                              <v-flex xs2 sm1 md1>

                                <v-layout justify-left>
                                  <v-btn icon ripple>
                                    <v-icon @click="ItemAktar2(dizaynData2,dizaynData,element)" color="red">
                                      arrow_back_ios
                                    </v-icon>
                                  </v-btn>
                                </v-layout>

                              </v-flex>


                              <v-flex xs2 sm1 md1>

                                  <div class="body-2 	 justify-center   grey--text">{{element.kayit.PNR_No}}</div>

                              </v-flex>

                              <v-flex xs2 sm2 md1>

                                  <div class="justify-center body-2 grey--text">
                                    {{element.kayit.Kayit_Tarihi | dateformat}}
                                  </div>
                              </v-flex>

              

                              <v-flex xs2 sm2 md2 pl-4>

                                  <div class="body-2  grey--text text-truncate">{{element.kayit.Cari_Kod}}</div>

                              </v-flex>

                              <v-flex xs2 sm2 md2>

                                  <div class="justify-center body-2 grey--text text-truncate">
                                    {{element.kayit.KisiIsim}}
                                  </div>
                              </v-flex>

                              <v-flex xs12 sm2 md1 pr-4>
                                  <div class="justify-center body-2  grey--text">{{element.FaturaTarihi | dateformat}}
                                  </div>
                              </v-flex>

                              <v-flex xs12 sm2 md2 pl-4>
                                  <div class="justify-center body-2  grey--text">{{element.VadeTarihi | dateformat}}
                                  </div>
                              </v-flex>

                              <v-flex xs12 sm2 md1>
                                    <div class="justify-center body-2  grey--text">{{element.kayit.EFatura}}</div>
                              </v-flex>

                              <v-flex xs12 sm2 md1>
                                <v-layout row wrap justify-left>

                                  <v-flex xs12 md12 sm12>
                                    <v-icon small @click="tarihDuzenle(element)" color="green">edit</v-icon>
                                  </v-flex>
                                </v-layout>
                              </v-flex>


                              <v-flex xs2 sm12 md12>
                                <v-divider></v-divider>
                              </v-flex>




                            </v-layout>
                          </v-flex>
                          <v-flex xs12 v-if="dizaynData2.length>0" md12>
                            <v-btn flat @click="faturala()" color="green" block> {{ $t('Invoice-Selected-Records') }} </v-btn>

                          </v-flex>



                        </v-layout>

                      </v-card>


                    </v-flex>

                  </v-layout>



                </v-flex>


                <v-dialog persistent v-model="tarihdialog" max-width="400px">
                  <v-card>
                    <v-card-text>
                      <v-form ref="formtarih" v-model="validtarih" lazy-validation>

                        <v-layout row wrap>

                          <v-flex pt-2 xs12 sm12 md12>
                            <tarihcomp v-if="secilenKayityedek!={}" :rules="[v => !!v || $t('Please-select-a-date')]"
                              :etiket="$t('Invoice-Date')" :detaygizle="false" v-bind:value="secilenKayityedek.FaturaTarihi"
                              v-model="secilenKayityedek.FaturaTarihi"></tarihcomp>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <tarihcomp v-if="secilenKayityedek!={}" :rules="[v => !!v || $t('Please-select-a-date')]"
                              :etiket="$t('Maturity-Date')" :detaygizle="false" v-bind:value="secilenKayityedek.VadeTarihi"
                              v-model="secilenKayityedek.VadeTarihi"></tarihcomp>
                          </v-flex>
                          <v-flex pr-1 pl-1 xs12 sm12 md6>


                            <v-btn color="blue darken-1" outline block flat @click="tarihIptal()">{{$t("cancel_button")}}
                            </v-btn>

                          </v-flex>

                          <v-flex pr-1 pl-1 xs12 sm12 md6>


                            <v-btn color="blue darken-1" outline block flat @click="tarihOk()">{{ $t('OK') }}</v-btn>

                          </v-flex>

                          <v-flex pr-1 pl-1 xs12 sm12 md6>

                            <v-btn color="red" outline block flat @click="tarihOkTumu()">{{ $t('Apply-All') }} </v-btn>

                          </v-flex>



                        </v-layout>
                      </v-form>
                    </v-card-text>


                  </v-card>

                </v-dialog>








              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>

          <v-dialog v-model="dialogfiltre" scrollable persistent max-width="500px">
            <v-card flat color="grey lighten-4">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex md12 xs12 sm12>
                              <pnrbul v-model="RaporTopluParams.PNR_No" hide-details>
                              </pnrbul>
                            </v-flex>
                            <v-flex md12 xs12 sm12>
                           <cariaracomp v-bind:etiket="$t('Currentcode_label')" v-bind:value="RaporTopluParams.Cari_Kod.kod" v-model="RaporTopluParams.Cari_Kod.kod" :Coper="true"></cariaracomp>
                            </v-flex>

                            <v-flex md6 xs12 sm6>
                              <v-select clearable :items="itemssaticitip" item-text="Aciklama" item-value="Kod"
                                v-model="RaporTopluParams.SaticiTip" :label="$t('Seller-Type')" hide-details="">
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <genelarama :autofocuss="true" apiname="SaticiAra" :tip="RaporTopluParams.SaticiTip"
                                :label="$t('Seller-Code')" v-model="RaporTopluParams.SaticiKod"></genelarama>
                            </v-flex>
                            <v-flex xs12 sm12 md12>

                              <v-text-field hide-details v-model="RaporTopluParams.Acente" :label="$t('Agency')">
                              </v-text-field>

                            </v-flex>
                            <v-flex xs12 sm12 md12>

                              <v-text-field hide-details v-model="RaporTopluParams.KarsiRezKod"
                                :label="$t('Counter-Booking-Code')">
                              </v-text-field>

                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <genelarama apiname="MasrafMerkeziAra" :label="$t('Expense-Center-v2')"
                                v-model="RaporTopluParams.MasrafMerkezi"></genelarama>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <genelarama apiname="MasrafMerkeziAra" :label="$t('Item-Expense-Centre')"
                                v-model="RaporTopluParams.KalemMasrafMerkezi"></genelarama>
                            </v-flex>
                            <v-flex xs12 sm12 md6>

                              <v-text-field hide-details v-model="RaporTopluParams.PozisyonNo" :label="$t('Position-No')">
                              </v-text-field>

                            </v-flex>
                            <v-flex xs12 sm12 md6>
                                <takipno v-model="RaporTopluParams.SatisGrubu" hide-details>
                              </takipno>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <v-select :items="itemsefaturami" item-text="text" item-value="value"
                                v-model="RaporTopluParams.EFatura" :label="$t('Invoice-Type')" hide-details="">
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-checkbox small v-model="RaporTopluParams.FaturalamayaHazir" :label="$t('Ready-for-Invoice')"
                                hide-details color="green">
                              </v-checkbox>


                            </v-flex>

                              <v-flex xs12 sm12 md12>
                              <v-checkbox small v-model="RaporTopluParams.SatisGrupTip" :label="$t('Visa-Sales')"
                                hide-details color="green">
                              </v-checkbox>
                            </v-flex>

                             <v-flex md12 xs12 sm12>
                              <v-select :items="itemsIcDis" item-text="text" item-value="value"
                                v-model="RaporTopluParams.Ic_Dis" :label="this.$t('Domestic-Abroad')" hide-details="">
                              </v-select>
                            </v-flex>

                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from "../../../api/auth";
  import tarihcomp from "../customcomp/tarihim";
  import helpers from "@/components/app/customcomp/helpers.js";
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
  import tool from "../coper/tools";
  import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
  import anatip from "@/components/app/coper/comp/anatip.vue";
  import rez from "../coper/rezervasyon";
  import genelarama from "@/components/app/coper/comp/genelarama.vue";
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import pnrbul from "@/components/app/coper/component/pnrbul.vue";
  import draggable from "vuedraggable";
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'
  import takipno from '../coper/component/takipno.vue';



  export default {
    data() {
      return {

        secilenKayit: {},
        secilenKayityedek: 
        {
          FaturaTarihi : null, 
          VadeTarihi : null,
          pnrNo:null
        },
        validtarih: true,
        tarihdialog: false,
        dizaynData2: [],
        dizaynData: [],
        itemssaticitip: rez.SaticiTip,
        itemsicdis: rez.IcDis,
        itemsopsiyon: rez.Opsiyon,

        itemsefaturami: [{
          text: this.$t('None'),
          value: null
        }, {
          text: 'E-Arşiv',
          value: 0
        }, {
          text: this.$t('E-Invoice'),
          value: 1
        }],

        itemsIcDis: [{
          text: this.$t('None'),
          value: null
        }, {
          text: 'Yurt İçi',
          value: 0
        }, {
          text: 'Yurt Disi',
          value: 1
        }],

        itemstarihtip: [{
          text: this.$t('Registration-Date'),
          value: 0
        }, {
          text: this.$t('Check-in-Date'),
          value: 1
        }, {
          text: this.$t('Check-out-Date'),
          value: 2
        }, {
          text: this.$t('Last-Leaving-Date'),
          value: 3
        }, {
          text: this.$t('First-Entry-Date'),
          value: 4
        }],

        itemskomisyon: [{
          text: this.$t('None'),
          value: false
        }, {
          text: this.$t('Available'),
          value: true
        }, {
          text: this.$t('All-v2'),
          value: null
        }],
        tarihTip: 0,

        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0
        },
        filtrevarmi: false,
        search: "",
        searchsatilanbilet: null,
        searchiadebilet: null,
        searchvoid: null,


        headerssatis: [{
            text: "PNR",
            value: "PNR_No",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Date'),
            value: "Kayit Tarihi",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Currentcode_label'),
            value: "PNR_CariKod",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Sales'),
            value: "SatisTutar",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Buying'),
            value: "AlisTutar",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Commission'),
            value: "PKomisyonTutar",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Payment'),
            value: "Odeme",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Balance'),
            value: "Bakiye",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Commission'),
            value: "KomisyonTL",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Profit'),
            value: "PNR_Kar",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Title_label'),
            value: "CariUnvan",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Company-No'),
            value: "SirketNo",
            width: "10%",
            align: "left"
          },
          {
            text:  this.$t('Sales') + " TL",
            value: "PNR_SatisTL",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Buying') + " TL",
            value: "PNR_AlisTL",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Commission') + " TL",
            value: "PNR_KomisyonTL",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('First-Entry'),
            value: "Donem1",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Last-Departure'),
            value: "Donem2",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Profit') + " TL",
            value: "PNR_KarTL",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Name-of-Seller'),
            value: "SaticiCariUnvan",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Booker'),
            value: "RezYapan",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Name'),
            value: "KisiIsimList",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Main-Type'),
            value: "AnaTip",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Agency'),
            value: "Acente",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Country_label'),
            value: "PNRUlke",
            width: "10%",
            align: "left"
          }
        ],

        Rapor: {

          SirketNo: null,
          PNR_No: null,
          Kayit_Tarihi1: null,
          Kayit_Tarihi2: null,
          Giris_Tarihi1: null,
          Giris_Tarihi2: null,
          Cikis_Tarihi1: null,
          Cikis_Tarihi2: null,
          SaticiTip: null,
          SaticiKod: null,
          CariKod: null,
          OperatorKod: null,
          MasrafMerkezi: null,
          FaturalamayaHazir: null,
          SatisGrupTip :null,
          EFatura: null,
          // PSirketNo: null, //eklendi
          // PPNR_No: null, //eklendi
          // PPNR_ParaBirimi: "TL", //eklendi
          // PKayitTarihBas: null, //eklendi
          // PKayitTarihBit: null, //eklendi
          // PDonem1Bas: null, //eklendi
          // PDonem1Bit: null, //eklendi
          // PDonem2Bas: null, //eklendi
          // PDonem2Bit: null, //eklendi
          // PFatTarihBas: null, //eklendi
          // PFatTarihBit: null, //eklendi
          // PKomFatTarihBas: null, //eklendi
          // PKomFatTarihBit: null, //eklendi
          // PCariKod: null, //eklendi
          // PSaticiTip: 1, //eklendi
          // PSaticiKod: null, //eklendi
          // PDosyaTip: null,
          // PDosya: null,
          // PAcente: null,
          // PPNRBir: null,
          // PCariHesapGrubu: null, //eklendi
          // PCariTip: null,
          // PSaticiGrup: null, //eklendi
          // PSaticiIc_Dis: null, //eklendi
          // PTurOp: null, //eklendi
          // PFaturali: null,
          // POpsiyon: null, //eklendi
          // PAnaTip: null, //eklendi
          // PCariAnaHesap: null, //eklendi
          // PIptalRaporu: null,
          // PRezGrupID: null,
          // PSatisGrubu: null,
          // PSatisGrupTip: null,
          // PSaticiOdemesiHesapla: null,
          // PMasrafMerkezi: null, //eklendi
          // PAcenteDepartmanID: null,
          // PPozisyonNo: null,
          // PSatisFaturaNo: null,
          // PMusteriOdemelilerHaric: null,
          // PReferans: null, //eklendi
          // PSatisTip1: null,
          // PSatisTip2: null,
          // PSatisTip3: null,
          // PSatisTip4: null,
          // PGelenFatTarihBas: null, //eklen
          // PGelenFatTarihBit: null, //eklendi
          // PProfilSablonId: null,
          // PKomisyonFaturali: null,
          // PGelenFaturali: null,
        },
        RaporTopluParams: {

          PNR_No: null,
          Cari_Kod: {
            id: null,
            isim: null,
            kod: null,
            isimAra: null,
          },
          Kayit_Tarihi1: null,
          Kayit_Tarihi2: null,
          Giris_Tarihi1: null,
          Giris_Tarihi2: null,
          Cikis_Tarihi1: null,
          Cikis_Tarihi2: null,
          SonCikis1: null,
          SonCikis2: null,
          IlkGiris1: null,
          IlkGiris2: null,
          FaturalamayaHazir: false,
          DosyaTip: null,
          Dosya: null,
          Acente: null,
          dptBolge: null,
          dptYonetim: null,
          dptDepartman: null,
          dptAltDepartman: null,
          dptBolum: null,
          FatGrup: null,
          MasrafMerkezi: null,
          SatisGrubu: null,
          PozisyonNo: null,
          SaticiTip: 0,
          SaticiKod: null,
          KalemMasrafMerkezi: null,
          EFatura: null,
          MasrafYeri: null,
          KarsiRezKod: null,
          Ic_Dis:null,
        },

        KayitTarihiBasla: null,
        KayitTarihiBitis: null,
        itemsairlinelist: [],
        hesapgurubu: [],
        masrafmerkezi: [],
        doviztipi: [],
        valid: true,
        tumsirketler: "",
        totalCount: 0,
        totalService: 0,
        totalAmount: 0,
        StartDate: null,
        EndDate: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: "",
        date2: null,
        menu2: false,
        dateFormatted2: "",
        modal2: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: "",

        renk1: "info",
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        searchcari: "",
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemssatis: [],
        itemsiade: [],
        itemsvoid: [],

        butondurum: true,
        snackbar: false,
        y: "top",
        x: "right",
        mode: "",
        timeout: 6000,
        text1: "",
        dictionary: {
          custom: {
            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            }
          }
        }
      };
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path;
      });
    },
    beforeMount: beforeMount,
    mounted() {
      this.$validator.localize("en", this.dictionary);
      this.el = this.$refs.fab.$el;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        CompanyCode: credentials.SirketKodu
      };

      this.$http
        .post(auth.API_URL + "api/currency/List", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        })
        .then(
          response => {
            this.doviztipi = response.body;
          },
          response => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            }
          }
        );

        var secilifat = window.localStorage.getItem('container_secilifat');
        if(secilifat != null){
        this.dizaynData2 = JSON.parse(secilifat);
        window.localStorage.removeItem('container_secilifat');
        }
f


      // this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      // if (this.sayfayetki.Status == true) {

      // } else {

      //   this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

      //     if (sonuc == true) {

      //       if (this.prevRoute != null) {
      //         var url = '#' + this.prevRoute

      //         window.open(url, '_self')
      //       } else {
      //         var url = '#/'
      //         window.open(url, '_self')
      //       }
      //     } else {

      //     }

      //   });

      // }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },

    components: {
      tarihcomp: tarihcomp,
      yetkidialog,
      hatadialog,
      anatip,
      genelarama,
      referansmerkezicomp,
      pnrbul,
      draggable,
      cariaracomp,
      takipno
    },
    watch: {},
    methods: {
      tarihIptal() {
        this.tarihdialog = false
      },
      tarihOk() {
        if (this.$refs.formtarih.validate()) {
          
          this.secilenKayit.FaturaTarihi = this.secilenKayityedek.FaturaTarihi
          
          var pnrprm=[];
          pnrprm.push(this.secilenKayityedek.pnrNo);
          let params = {
          PNR_List:pnrprm,
          FaturaTarihi:this.secilenKayityedek.FaturaTarihi
        }
          tool.http_post(this, 'VadeTarihiHesapla', params).then(
          response => {
            if (response.body.Status == true) {
              this.secilenKayit.VadeTarihi = response.body.data[0].VadeTarihi
            } else {
              this.secilenKayit.VadeTarihi = this.secilenKayityedek.VadeTarihi
            }
          }
          )

         

          this.tarihdialog = false
        }

      },
      tarihOkTumu() {
        if (this.$refs.formtarih.validate()) {
          
          this.dizaynData2.forEach(element => {
            element.VadeTarihi = this.secilenKayityedek.VadeTarihi;
            element.FaturaTarihi = this.secilenKayityedek.FaturaTarihi;
        });

          this.tarihdialog = false
        }

      },

      tarihDuzenle(val) {
        this.secilenKayit = val

        this.secilenKayityedek.FaturaTarihi = val.FaturaTarihi
        this.secilenKayityedek.VadeTarihi = val.VadeTarihi
        this.secilenKayityedek.pnrNo=val.kayit.PNR_No
        
        this.tarihdialog = true

      },
      getDateNow() {
        return helpers.getDateNow();
      },
      faturala() {

        var degerler = []


        this.dizaynData2.forEach(element => {
          var kayit = {
            PNR_No: element.kayit.PNR_No,
            VadeTarihi: element.VadeTarihi,
            FaturaTarihi: element.FaturaTarihi
          }
          degerler.push(kayit)
        });



        window.localStorage.setItem('container_toplufatura', JSON.stringify(degerler));
        var url = '#/fatura/copertoplufaturaislem'
        window.open(url, '_target')
      },

      ItemAktarTumu(kaynak, hedef) {
      
       kaynak.forEach(element => {

        let params = {
          PNR_List: element.PNR_No
        }
        tool.http_post(this, 'VadeTarihiHesapla', params).then(
          response => {
            if (response.body.Status == true) {

              var yenikayit = {
                kayit: element,
                VadeTarihi: response.body.data[0].VadeTarihi,
                FaturaTarihi: response.body.data[0].FaturaTarihi
              }
              hedef.push(yenikayit);
            } else {
              var yenikayit = {
                kayit: element,
                VadeTarihi: this.getDateNow(),
                FaturaTarihi: this.getDateNow()
              }
              hedef.push(yenikayit);
            }
          },
          response => {
            var yenikayit = {
              kayit: element,
              VadeTarihi: this.getDateNow(),
              FaturaTarihi: this.getDateNow()
            }
            hedef.push(yenikayit);
          }
        );
         

         
        });
        kaynak.splice(0, kaynak.length)
      },


      ItemAktar(kaynak, hedef, item) {

        var n = kaynak.indexOf(item);

        kaynak.splice(n, 1);

        let params = {
          PNR_List: [item.PNR_No]
        }
        tool.http_post(this, 'VadeTarihiHesapla', params).then(
          response => {
            if (response.body.Status == true) {

              var yenikayit = {
                kayit: item,
                VadeTarihi: response.body.data[0].VadeTarihi,
                FaturaTarihi: response.body.data[0].FaturaTarihi
              }
              hedef.push(yenikayit);
            } else {
              var yenikayit = {
                kayit: item,
                VadeTarihi: this.getDateNow(),
                FaturaTarihi: this.getDateNow()
              }
              hedef.push(yenikayit);
            }
          },
          response => {
            var yenikayit = {
              kayit: item,
              VadeTarihi: this.getDateNow(),
              FaturaTarihi: this.getDateNow()
            }
            hedef.push(yenikayit);
          }
        );
      },
      ItemAktar2(kaynak, hedef, item) {

        var n = kaynak.indexOf(item);

        kaynak.splice(n, 1);


        hedef.push(item.kayit);


      },
      onMove({
        relatedContext,
        draggedContext
      }) {
        const relatedElement = relatedContext.element;
        const draggedElement = draggedContext.element;
        return ((!relatedElement || !relatedElement.fixed) && !draggedElement.fixed);

      },
      HataYonetimi(response, request, baslik) {
        if (response.status === 500) {
          //Internal Server Error
          this.$refs.hatadialog.open(response, request, baslik);
        } else {
          this.text1 = "Service Unavailable -" + baslik;
          this.snackbar = true;
        }
      },

      git(val) {
        var url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val.PNR_No;
        window.open(url, "_target");
      },
      getList: getList,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    },
    computed: {

      dragOptions() {
        return {
          animation: 0,
          group: "description",
          disabled: !this.editable,
          ghostClass: "ghost"
        };
      }
    },
  };

  function filtrele() {
    this.dialogfiltre = true;
  }

  function filtrekayit() {
    this.filtrevarmi = true;
    this.dialogfiltre = false;
    this.getList();
  }

  function filtreiptal() {
    this.filtrevarmi = false;
    this.dialogfiltre = false;

    this.RaporTopluParams.PNR_No = null
    this.RaporTopluParams.CariKod = null
    this.RaporTopluParams.FaturalamayaHazir = false
    this.RaporTopluParams.DosyaTip = null
    this.RaporTopluParams.Dosya = null
    this.RaporTopluParams.Acente = null
    this.RaporTopluParams.FatGrup = null
    this.RaporTopluParams.MasrafMerkezi = null
    this.RaporTopluParams.SatisGrubu = null
    this.RaporTopluParams.PozisyonNo = null
    this.RaporTopluParams.SaticiTip = null
    this.RaporTopluParams.SaticiKod = null
    this.RaporTopluParams.KalemMasrafMerkezi = null
    this.RaporTopluParams.EFatura = null
    this.RaporTopluParams.MasrafYeri = null
    this.RaporTopluParams.KarsiRezKod = null
    this.RaporTopluParams.Ic_Dis = null
    

  }

  function getList() {
    if (this.$refs.formgunluksatis.validate()) {

      this.dizaynData2 = [];
      this.dizaynData = [];

      var bastarih = new Date(this.KayitTarihiBasla);
      var bittarih = new Date(this.KayitTarihiBitis);

      if (this.tarihTip == 0) {

        this.RaporTopluParams.Kayit_Tarihi1 = this.KayitTarihiBasla
        this.RaporTopluParams.Kayit_Tarihi2 = this.KayitTarihiBitis

        this.RaporTopluParams.Giris_Tarihi1 = null
        this.RaporTopluParams.Giris_Tarihi2 = null

        this.RaporTopluParams.Cikis_Tarihi1 = null
        this.RaporTopluParams.Cikis_Tarihi2 = null

        this.RaporTopluParams.SonCikis1 = null
        this.RaporTopluParams.SonCikis2 = null

        this.RaporTopluParams.IlkGiris1 = null
        this.RaporTopluParams.IlkGiris2 = null


      } else if (this.tarihTip == 1) {


        this.RaporTopluParams.Kayit_Tarihi1 = null
        this.RaporTopluParams.Kayit_Tarihi2 = null

        this.RaporTopluParams.Giris_Tarihi1 = this.KayitTarihiBasla
        this.RaporTopluParams.Giris_Tarihi2 = this.KayitTarihiBitis

        this.RaporTopluParams.Cikis_Tarihi1 = null
        this.RaporTopluParams.Cikis_Tarihi2 = null

        this.RaporTopluParams.SonCikis1 = null
        this.RaporTopluParams.SonCikis2 = null

        this.RaporTopluParams.IlkGiris1 = null
        this.RaporTopluParams.IlkGiris2 = null


      } else if (this.tarihTip == 2) {


        this.RaporTopluParams.Kayit_Tarihi1 = null
        this.RaporTopluParams.Kayit_Tarihi2 = null

        this.RaporTopluParams.Giris_Tarihi1 = null
        this.RaporTopluParams.Giris_Tarihi2 = null

        this.RaporTopluParams.Cikis_Tarihi1 = this.KayitTarihiBasla
        this.RaporTopluParams.Cikis_Tarihi2 = this.KayitTarihiBitis

        this.RaporTopluParams.SonCikis1 = null
        this.RaporTopluParams.SonCikis2 = null

        this.RaporTopluParams.IlkGiris1 = null
        this.RaporTopluParams.IlkGiris2 = null

      } else if (this.tarihTip == 3) {

        this.RaporTopluParams.Kayit_Tarihi1 = null
        this.RaporTopluParams.Kayit_Tarihi2 = null

        this.RaporTopluParams.Giris_Tarihi1 = null
        this.RaporTopluParams.Giris_Tarihi2 = null

        this.RaporTopluParams.Cikis_Tarihi1 = null
        this.RaporTopluParams.Cikis_Tarihi2 = null

        this.RaporTopluParams.SonCikis1 = this.KayitTarihiBasla
        this.RaporTopluParams.SonCikis2 = this.KayitTarihiBitis

        this.RaporTopluParams.IlkGiris1 = null
        this.RaporTopluParams.IlkGiris2 = null

      } else if (this.tarihTip == 4) {

        this.RaporTopluParams.Kayit_Tarihi1 = null
        this.RaporTopluParams.Kayit_Tarihi2 = null

        this.RaporTopluParams.Giris_Tarihi1 = null
        this.RaporTopluParams.Giris_Tarihi2 = null

        this.RaporTopluParams.Cikis_Tarihi1 = null
        this.RaporTopluParams.Cikis_Tarihi2 = null

        this.RaporTopluParams.SonCikis1 = null
        this.RaporTopluParams.SonCikis2 = null

        this.RaporTopluParams.IlkGiris1 = this.KayitTarihiBasla
        this.RaporTopluParams.IlkGiris2 = this.KayitTarihiBitis

      }


      if (bastarih <= bittarih) {

        this.progress = true;
        this.load1 = false;


        var RaporParam = {}

        RaporParam.PNR_No = this.RaporTopluParams.PNR_No


        RaporParam.Kayit_Tarihi1 = this.RaporTopluParams.Kayit_Tarihi1
        RaporParam.Kayit_Tarihi2 = this.RaporTopluParams.Kayit_Tarihi2
        RaporParam.Giris_Tarihi1 = this.RaporTopluParams.Giris_Tarihi1
        RaporParam.Giris_Tarihi2 = this.RaporTopluParams.Giris_Tarihi2
        RaporParam.Cikis_Tarihi1 = this.RaporTopluParams.Cikis_Tarihi1
        RaporParam.Cikis_Tarihi2 = this.RaporTopluParams.Cikis_Tarihi2
        RaporParam.SonCikis1 = this.RaporTopluParams.SonCikis1
        RaporParam.SonCikis2 = this.RaporTopluParams.SonCikis2
        RaporParam.IlkGiris1 = this.RaporTopluParams.IlkGiris1
        RaporParam.IlkGiris2 = this.RaporTopluParams.IlkGiris2
        RaporParam.KarsiRezKod = this.RaporTopluParams.KarsiRezKod
        
        


        if (this.RaporTopluParams.Cari_Kod != null) {

          if (this.RaporTopluParams.Cari_Kod.kod != null) {
            RaporParam.Cari_Kod = this.RaporTopluParams.Cari_Kod.kod
          } else {
            RaporParam.Cari_Kod = null
          }
        } else {
          RaporParam.Cari_Kod = null
        }

        RaporParam.SaticiTip = this.RaporTopluParams.SaticiTip


        if (this.RaporTopluParams.SaticiKod != null) {
          RaporParam.SaticiKod = this.RaporTopluParams.SaticiKod.kod
        } else {
          RaporParam.SaticiKod = this.RaporTopluParams.SaticiKod
        }


        if (this.RaporTopluParams.KalemMasrafMerkezi != null) {
          RaporParam.KalemMasrafMerkezi = this.RaporTopluParams.KalemMasrafMerkezi.kod
        } else {
          RaporParam.KalemMasrafMerkezi = null
        }


        if (this.RaporTopluParams.MasrafMerkezi != null) {
          RaporParam.MasrafMerkezi = this.RaporTopluParams.MasrafMerkezi.kod
        } else {
          RaporParam.MasrafMerkezi = null
        }
        RaporParam.FaturalamayaHazir = this.RaporTopluParams.FaturalamayaHazir
        RaporParam.Acente = this.RaporTopluParams.Acente
        RaporParam.SatisGrubu = this.RaporTopluParams.SatisGrubu
        RaporParam.PozisyonNo = this.RaporTopluParams.PozisyonNo
        RaporParam.EFatura = this.RaporTopluParams.EFatura
        RaporParam.Ic_Dis = this.RaporTopluParams.Ic_Dis
        
        if(this.RaporTopluParams.SatisGrupTip==true)
        {
          RaporParam.SatisGrupTip=1;
        }
        
        var params = {
          Value: RaporParam
        }

        this.progress = false;
        this.load1 = true;

        tool.http_post(this, 'KesilecekSatisFaturasiList', params).then(
          response => {
            if (response.body.Status == true) {
              this.dizaynData = response.body.data
              window.localStorage.removeItem('container_toplufatura')

            } else {
              this.text1 = response.body.ErrorList[0]
              this.snackbar = true
            }
          },
          response => {
            this.text1 = 'Hata Oluştu, tekrar deneyiniz'
            this.snackbar = true
          }
        );
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true;
      }
    }
  }

  function beforeMount() {}
</script>
<style>
  .project.complete {
    border-left: 4px solid green;
  }

  .project.ongoing {
    border-left: 4px solid orange;
  }

  .project.overdue {
    border-left: 4px solid red;
  }

  .scrollbar1 {
width: 100%;
  height:700px;
  background-color:white;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-color: rebeccapurple green;
  scrollbar-width: auto;
  }

  #wrapper {
    text-align: center;
    width: 500px;
    margin: auto;
  }

  /*
 *  STYLE 1
 */

  #style-11::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  }

  #style-11::-webkit-scrollbar {
    width: 12px;
    background-color: #F5F5F5;
  }

  #style-11::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 8px rgba(0, 0, 0, .3);

  }
</style>